import React from "react";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Button, FormHelperText, IconButton } from "@material-ui/core";
import { Fragment, useState } from "react";
import { GrFormClose } from "react-icons/gr";
import { toast } from "react-toastify";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { ClipLoader } from "react-spinners";
import { apiJson } from "../../../api/Api";

const useStyles = makeStyles(() => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#fff",
    padding: 24,
    borderRadius: 8,
    outline: "none",
    minWidth: 400,
    position: "relative",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
    textAlign: "center",
  },
  discription: {
    color: "#6B747C",
    textAlign: "center",
    maxWidth: 400,
  },
  closeBtn: {
    position: "absolute",
    top: 12,
    right: 12,
  },
}));

const emailValidation = Yup.object().shape({
  email: Yup.string().email().required("Required"),
});

export default function ResetPasswordModal() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [changing, setChanging] = useState(false);
  const emailValues = {
    email: "",
  };

  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const showSuccess = () => {
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const changePass = (values) => {
    setChanging(true);
    apiJson.auth
      .resetPassEmail({
        email: values.email,
        redirect_url: "https://vendor.alisouq.com/reset-password",
      })
      .then((response) => {
        setChanging(false);
        if (response.success) {
          message = "Verification has been sent to your email address";
          showSuccess();
          setOpen(false);
        } else if (!response.status) {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        } else {
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
                ? response.errors
                : "something went wrong";
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          }
        }
      });
  };

  return (
    <>
      <Button
        variant="outlined"
        style={{
          border: "none",
          textDecoration: "underline",
          width: "fit-content",
          alignSelf: "end",
        }}
        type="button"
        onClick={() => setOpen(true)}
      >
        Forget Password?
      </Button>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        className={classes.modal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <div className={classes.paper}>
          {/* Close Button X */}
          <IconButton
            className={classes.closeBtn}
            sty
            onClick={() => setOpen(false)}
          >
            <GrFormClose size={20} />
          </IconButton>

          {/* Form */}
          <Formik
            initialValues={emailValues}
            validationSchema={emailValidation}
            enableReinitialize
            onSubmit={(values) => changePass(values)}
          >
            {({ errors, touched }) => (
              <Form>
                {/* Title */}
                <h2 className={classes.title}>Forget Your Password?</h2>
                {/* Discription */}
                <p className={classes.discription}>
                  Enter your email address and we'll send you a link to reset
                  your password
                </p>

                {/* Input */}
                <Box>
                  <div className="label">Email</div>
                  <Field
                    type="email"
                    name="email"
                    variant="outline"
                    style={{ width: "100%" }}
                  />
                  {touched.email && errors.email && (
                    <FormHelperText error>{errors.email}</FormHelperText>
                  )}
                </Box>

                {/* Submit Btn */}
                <Button
                  type="submit"
                  style={{ height: 40, marginTop: 40 }}
                  size="lg"
                  disabled={changing}
                  fullWidth
                  variant="contained"
                  color="primary"
                >
                  {changing ? (
                    <div>
                      <ClipLoader color="#fff" loading size={25} />
                    </div>
                  ) : (
                    "Submit Email"
                  )}
                </Button>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  );
}
